<template>
    <div class="tile">
        <div class="tile-title">
            <h2>Coupon Restrictions</h2>
        </div>
        <div class="tile-content">
            <ul class="list" v-if="hasRestrictions">
                <li v-for="{type, quantity, amount, currency, time, ids} in restrictions" class="list-item">
                    <div class="list-item-content">
                        <span class="text-muted inline-s">{{type | unKebabCase}}</span>
                        <span v-if="quantity">{{quantity}}</span>
                        <span v-else-if="amount && currency">{{currency | currencySign}}{{amount}}</span>
                        <span v-else-if="time">{{time}}</span>
                        <ul v-if="ids.length" class="list list-compact list-group">
                            <li v-for="id in ids" class="list-item">
                                <span :title="id">{{id}}</span>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
            <p v-else class="text-muted">There are no restrictions for this coupon.</p>
        </div>
    </div>
</template>

<script>
    import vIcon from '@/components/form/v-icon';
    import format from '@/common/format';

    export default {
        components: {vIcon},
        name: 'coupon-restrictions-summary',
        props: {
            coupon: Object,
        },
        computed: {
            hasRestrictions() {
                return this.restrictions.length;
            },
            restrictions() {
                return this.coupon.restrictions.map(
                    ({
                        type, quantity, amount, currency, time: timeString, ...rest
                    }) => {
                        const time = format.dateTime(timeString);
                        /**
                         * Type is mandatory
                         * Quantity, Amount, currency are optional
                         * ...rest params contains IDs of the restricted resources under a
                         * variant attribute name invoicesIds, subscriptionIds, etc
                         */
                        const ids = (() => {
                            if (rest) {
                                const key = Object.keys(rest)[0];
                                if (key && rest[key].length) {
                                    return rest[key];
                                }
                            }
                            return [];
                        })();
                        return {
                            type, quantity, amount, currency, time, ids,
                        };
                    },
                );
            },
        },
    };
</script>
